import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { M as a, D as o, T as d } from "./abstract-base-8edf0a84-e11d45a3.js";
import { s as _ } from "./lifecycle-decorators-ecc4e836-92da4b80.js";
var f = {
    header: "HDR",
    siteNav: "TN",
    footer: "FTR"
  },
  T = {
    0: "Hdr_lvl0",
    1: "Hdr_lvl1"
  },
  p = {
    level_1: "TN_lvl1",
    level_2: "TN_lvl2",
    level_3: "TN_lvl3",
    level_4: "TN_lvl4"
  },
  L = {
    prefix: "data-metrics",
    get location() {
      return "".concat(this.prefix, "-location");
    },
    get section() {
      return "".concat(this.prefix, "-section");
    }
  },
  N = {
    selectedLink: "Site_lvl0",
    links: "Site_lvl1_SiteSelector",
    level1LangSelector: "Site_lvl1_LocLangSelector",
    level2LangSelector: "Site_lvl2_LocLangSelector"
  };
function g(i) {
  switch (i) {
    case 1:
      return p.level_2;
    case 2:
      return p.level_3;
    case 3:
      return p.level_4;
    default:
      return null;
  }
}
var v = Object.defineProperty,
  u = Object.getOwnPropertyDescriptor,
  c = function c(i, r, l, e) {
    for (var t = e > 1 ? void 0 : e ? u(r, l) : r, s = i.length - 1, n; s >= 0; s--) (n = i[s]) && (t = (e ? n(r, l, t) : n(t)) || t);
    return e && t && v(r, l, t), t;
  };
var h = {
    skipFirstUpdated: !1,
    runOnSlotchange: !1
  },
  C = function C() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : h,
      i = _ref.skipFirstUpdated,
      r = _ref.runOnSlotchange;
    return function (l) {
      var e = /*#__PURE__*/function (_l) {
        _inherits(e, _l);
        function e() {
          _classCallCheck(this, e);
          return _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
        }
        _createClass(e, [{
          key: "updateAnalytics",
          /**
           * @abstract
           */
          value: function updateAnalytics() {}
        }, {
          key: "connectedCallback",
          value: function connectedCallback() {
            _get(_getPrototypeOf(e.prototype), "connectedCallback", this).call(this), r && this.addEventListener("slotchange", this.updateAnalytics);
          }
        }, {
          key: "firstUpdated",
          value: function firstUpdated() {
            _get(_getPrototypeOf(e.prototype), "firstUpdated", this).call(this), i || this.updateAnalytics();
          }
        }, {
          key: "willUpdate",
          value: function willUpdate(t) {
            _get(_getPrototypeOf(e.prototype), "willUpdate", this).call(this, t), t.has("metricsSection") && this.metricsSection && o(this, d.METRICS_SECTION_CHANGE), t.has("metricsLocation") && this.metricsLocation && o(this, d.METRICS_LOCATION_CHANGE), t.has("metricsID") && this.metricsID && o(this, d.METRICS_ID_CHANGE);
          }
        }]);
        return e;
      }(l);
      return c([a({
        attribute: "data-metrics-section",
        reflect: !0
      })], e.prototype, "metricsSection", 2), c([a({
        attribute: "data-metrics-location"
      })], e.prototype, "metricsLocation", 2), c([a({
        attribute: "data-id"
      })], e.prototype, "metricsID", 2), e = c([_("Analytics")], e), e;
    };
  };
export { g as A, C, T as L, N, L as T, f as h, p as v };